/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 17:29:02
 * @Last Modified by:   Josselin Hubert
 * @Last Modified time: 2020-09-01 17:29:02
 */



import en from "./locales/en"
import fr from "./locales/fr"

export default {
  en,
  fr
}
